import { motion } from "framer-motion";
import { whatsappLink } from "@/lib/brand";

// Floating WhatsApp button, fixed bottom-right, with pre-filled message.
export const FloatingWhatsApp = () => {
  return (
    <motion.a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat with IndiAbode on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200, damping: 15 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-[#25D366] shadow-[0_8px_24px_rgba(37,211,102,0.45)] flex items-center justify-center"
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <svg viewBox="0 0 32 32" className="h-7 w-7 relative" fill="#fff" aria-hidden="true">
        <path d="M16.004 3c-7.17 0-12.99 5.82-12.99 12.99 0 2.29.6 4.52 1.74 6.49L3 29l6.7-1.75a12.9 12.9 0 0 0 6.3 1.62h.01c7.17 0 12.99-5.82 12.99-12.99S23.17 3 16.004 3zm7.6 18.36c-.32.9-1.87 1.72-2.57 1.78-.66.06-1.28.3-4.28-.9-3.6-1.42-5.9-5.1-6.08-5.34-.18-.24-1.46-1.94-1.46-3.7s.92-2.62 1.25-2.98c.32-.36.7-.45.94-.45.24 0 .47 0 .68.01.22.01.51-.08.8.61.32.75 1.08 2.6 1.18 2.79.1.19.16.42.03.66-.12.24-.18.39-.36.6-.18.21-.38.47-.54.63-.18.18-.37.38-.16.74.21.36.94 1.55 2.02 2.51 1.39 1.24 2.56 1.62 2.92 1.8.36.18.57.15.78-.09.21-.24.9-1.05 1.14-1.41.24-.36.48-.3.8-.18.32.12 2.06.97 2.42 1.15.36.18.6.27.69.42.09.15.09.87-.23 1.77z"/>
      </svg>
    </motion.a>
  );
};

export default FloatingWhatsApp;
